import { render, staticRenderFns } from "./Slotracha.vue?vue&type=template&id=84761412&scoped=true&"
import script from "./Slotracha.vue?vue&type=script&lang=js&"
export * from "./Slotracha.vue?vue&type=script&lang=js&"
import style0 from "./Slotracha.vue?vue&type=style&index=0&id=84761412&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84761412",
  null
  
)

export default component.exports